module.exports = __webpack_public_path__ + "img/matt-rhodes-alley.585b610d.jpg";